import { Box, Avatar, Typography } from "@mui/material";
import { tokens } from "../../../theme";

export interface AuditEntry {
  id: number;
  componentName: string;
  assigneeId?: number;
  assigneeName?: string;
  assigneeAvatar?: string;
  auditDate: string;
  timeInfo: string;
  status: "overdue" | "in_danger" | "safe";
}

interface UpcomingAuditsCardProps {
  entry: AuditEntry;
  colors: ReturnType<typeof tokens>;
  onClick: () => void;
}

const UpcomingAuditsCard = ({
  entry,
  colors,
  onClick,
}: UpcomingAuditsCardProps) => {
  const statusColor =
    entry.status === "overdue"
      ? "#E11D48"
      : entry.status === "in_danger"
        ? "#f59e0b"
        : "#10b981";

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        p: 1,
        borderRadius: "16px",
        backgroundColor: colors.primary[900],
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        "&:hover": { backgroundColor: colors.primary[700] + "40" },
        minHeight: 64,
      }}
    >
      {/* Avatar */}
      <Avatar
        src={entry.assigneeAvatar}
        sx={{
          width: 36,
          height: 36,
          flexShrink: 0,
          fontSize: "0.8rem",
          fontWeight: 700,
          backgroundColor: colors.primary[600],
          border: `1.5px solid ${colors.primary[400]}`,
        }}
      >
        {entry.assigneeName?.[0] ?? "?"}
      </Avatar>

      {/* Info */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {/* Component name */}
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.8rem",
            color: colors.primary[100],
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {entry.componentName}
        </Typography>

        {/* Assignee name */}
        <Typography
          sx={{
            fontSize: "0.72rem",
            color: colors.primary[500],
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {entry.assigneeName ?? "Unassigned"}
        </Typography>

        {/* Audit date */}
        <Typography
          sx={{
            fontSize: "0.68rem",
            color: statusColor,
            fontWeight: 600,
            mt: 0.3,
          }}
        >
          {entry.timeInfo}
        </Typography>
      </Box>
    </Box>
  );
};

export default UpcomingAuditsCard;
